import i18n from '@/i18n';
// import { context, apiVersion } from '@/api/config.js';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export async function viewImages(urls = []) {
  const container = document.createElement('div');
  urls.forEach((url) => {
    const img = document.createElement('img');
    img.src = url;
    container.appendChild(img);
  });
  const viewer = new Viewer(container, {
    toolbar: false,
    button: false,
    title: false,
    navbar: false,
    hidden: function () {
      viewer.destroy();
    },
    ready: function () {},
  });
  viewer.show();
}

export function convertToBlob(base64) {
  var base64Arr = base64.split(',');
  var imgtype = '';
  var base64String = '';
  if (base64Arr.length > 1) {
    base64String = base64Arr[1];
    imgtype = base64Arr[0].substring(
      base64Arr[0].indexOf(':') + 1,
      base64Arr[0].indexOf(';')
    );
  }
  var bytes = atob(base64String);
  var bytesCode = new ArrayBuffer(bytes.length);
  var byteArray = new Uint8Array(bytesCode);
  for (var i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i);
  }
  return new Blob([bytesCode], { type: imgtype });
}
export function blobToFiles({ blob, fileName, type }) {
  return new window.File([blob], fileName, {
    type: type,
  });
}

// 下載文件
export const downloadFile = function (res) {
  // 下載文件
  let blobData = new Blob([res.data]);
  let fileName = res.headers['content-disposition']
    ? res.headers['content-disposition'].split(';')[1].split('=')[1]
    : 'unknown';
  fileName = fileName ? decodeURI(fileName) : '.txt';
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blobData, fileName);
  } else {
    let elink = document.createElement('a');
    elink.download = fileName;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blobData);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  }
};

// 防止ios 文件上傳報錯
export function fileToBlob(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onloadend = function (e) {
      const blob = new Blob([e.target.result], {
        type: file.type,
      });
      resolve({
        blob,
        name: file.name,
        type: file.type,
        size: file.size,
      });
    };
    fr.onerror = function (e) {
      reject(e);
    };
    fr.readAsArrayBuffer(file);
  });
}

// 上傳附件
export function selectFile({
  maxSize = 5 * 1024 * 1024,
  accept,
  multiple = true,
  verifyType = [],
} = {}) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    if (accept) {
      input.setAttribute('accept', accept);
    }
    input.setAttribute('type', 'file');
    if (multiple) {
      input.setAttribute('multiple', multiple);
    }
    input.style.display = 'none';

    input.onchange = async () => {
      const fs = input.files;
      for (let i = 0; i < fs.length; i++) {
        const file = fs.item(i);
        const suffix = file.name
          .substring(file.name.lastIndexOf('.') + 1)
          .toUpperCase();
        // 驗證文件類型
        if (verifyType.length && !verifyType.some((type) => type === suffix)) {
          reject(new Error('FILE_TYPE_ILLEGAL'));
          return;
        }
        if (file.size === 0) {
          reject(new Error('FILE_SIZE_ZERO'));
          return;
        }
        if (file.size > maxSize) {
          reject(new Error('FILE_SIZE_TOO_LARGE'));
          return;
        }
      }
      resolve(multiple ? fs : fs.item(0));
    };
    document.body.appendChild(input);
    input.click();
  });
}

export function beforeUploadTips(file, size = 10) {
  const isSize = file.size / 1024 / 1024 < size;
  if (file.size == 0) {
    // 文件大小 判斷 0KB
    return i18n.t(`Common.message.uploadSize0KB`);
  }
  if (!isSize) {
    const newSize = Math.floor((Number(size) / 1024) * 100) / 100;
    return i18n.t(`Common.message.uploadSizeFormat`, [
      size >= 1024 ? `${newSize}G` : `${size}MB`,
    ]);
  } else {
    return false;
  }
}

export async function beforeUpload(file, size = 10) {
  if (!file) return;
  const fileError = beforeUploadTips(file, size);
  if (!fileError) {
    // 驗證通過
    // 文件格式處理，防止ios 文件上傳報錯
    const newFile = await fileToBlob(file);
    return newFile;
  } else {
    return {
      type: 'error',
      textTip: fileError,
    };
  }
}

